import { render, staticRenderFns } from "./BaseLoadingNavbar.vue?vue&type=template&id=5165933a"
import script from "./BaseLoadingNavbar.vue?vue&type=script&lang=js"
export * from "./BaseLoadingNavbar.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingNavbar.vue?vue&type=style&index=0&id=5165933a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports